module.exports = __webpack_public_path__ + "img/19.moon-set-light.5091ad42.svg";